// Validation
export function validateSection(sectionKey, state) {
  const errors = [];

  switch (sectionKey) {
    case 'companyDetails':
      if (!state.companyDetails.companyName) errors.push('Company name is required');
      if (!state.companyDetails.abn) errors.push('ABN is required');
      if (!state.companyDetails.address) errors.push('Address is required');
      if (!state.companyDetails.phone) errors.push('Phone number is required');
      if (!state.companyDetails.email) errors.push('Email address is required');
      break;

    case 'companyOverview':
      if (!state.companyOverview.servicesSummary) errors.push('Services summary is required');
      if (!state.companyOverview.companyStructure) errors.push('Company structure is required');
      break;

    case 'experience':
      if (!state.experience.yearsInBusiness) errors.push('Years in business is required');
      if (!state.experience.numberOfStaff) errors.push('Number of staff is required');
      if((state.experience.aeiTraining || state.experience.isanaTraining || state.experience.maraTraining) && !state.experience.trainingCertificate) errors.push('Training Certificate is required')
      if (!state.experience.studentFees) errors.push('Student fees information is required');
      if (!state.experience.marketingChannels) errors.push('Marketing channels are required');
      if (!state.experience.targetCountries) errors.push('Target countries are required');
      break;

    case 'benefits':
      if (!state.benefits.benefitsDescription) errors.push('Benefits description is required');
      break;

    case 'referees':
      state.referees.forEach((ref, idx) => {
        if (!ref.companyName) errors.push(`Referee ${idx + 1}: Company name is required`);
        if (!ref.contactName) errors.push(`Referee ${idx + 1}: Contact name is required`);
        if (!ref.email) errors.push(`Referee ${idx + 1}: Email is required`);
      });
      break;

    case 'declaration':
      if (!state.declaration.informationTrue) errors.push('Please confirm information is true');
      if (!state.declaration.refereesProvided) errors.push('Please confirm referees are provided');
      if (!state.declaration.proofAttached) errors.push('Please confirm proof is attached');
      if (!state.declaration.agreeToTerms) errors.push('Please agree to terms');
      if (!state.declaration.agreeToPrivacy) errors.push('Please agree to privacy notice');
      if (!state.declaration.understandResponsibilities) errors.push('Please confirm understanding');
      if (!state.declaration.representativeName) errors.push('Representative name is required');
      if (!state.declaration.representativeSignature) errors.push('Representative Signature is required');
      if (!state.declaration.representativePosition) errors.push('Representative position is required');
      if (!state.declaration.date) errors.push('Date is required');
      break;
  }

  return { valid: errors.length === 0, errors };
}